import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { RulesTypes } from 'Common/enums';
import DeleteMerchantOverrideModal from '../DeleteMerchantOverrideModal';
import styles from './RemoveOverrideBtn.css';

type Props = {
    id: string;
    showButton?: boolean;
    revision: number;
    ruleType: RulesTypes;
};

const RemoveOverrideBtn = ({ showButton, id, revision, ruleType }: Props) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const onRemoveClick = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <DeleteMerchantOverrideModal
                closeModal={closeModal}
                isOpen={showModal}
                id={id}
                revision={revision}
                ruleType={ruleType}
            />
            <div className={styles.container}>
                {showButton && (
                    <Button
                        dataTestId='remove-override-button'
                        variant='contextual-secondary'
                        onClick={handleOnClickEvent(onRemoveClick)}
                        onKeyDown={handleKeyEvent(onRemoveClick)}
                    >
                        {t('Remove Override')}
                    </Button>
                )}
            </div>
        </>
    );
};

export default RemoveOverrideBtn;
